import React, { useContext, useEffect, useState } from "react";
import MissionStatistics from "./MissionStatistics";
import MissionProcessSteps from "./MissionProcessSteps";
import { MissionContext } from "modules/pvs_activities/components/contexts/MissionTasksContext";
import { useSelector } from "react-redux";
import { USER_ROLES } from "constants";
import TaskTabsFilters from "modules/pvs_activities/components/mission/mission_components/TaskTableFilters";
import { getMissionWorkFlowStatistics } from "helpers";
import { Skeleton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetExpertsByMissionIdQuery } from "modules/pvs_activities/redux/service/missions";
import { EXPERTS_POSITIONS } from "modules/pvs_activities/constants";
let filteredProcessesBasedOnRole = [];

const filterConfig = {
    showCountry: false,
    showMissionType: false,
    showMissionPhase: true,
    showDueDate: true,
    showStatus: true,
    showPersonAssigned: true,
};

const MissionWorkFlow = ({ mission_context: missionContext = {} }) => {
    const { id } = useParams();
    const { t } = useTranslation();

    const authData = useSelector(s => s.auth.data);
    // const missionContext = useContext(MissionContext);
    const [missionProcesses, setMissionProcesses] = useState([]);
    const [movements, setMovements] = useState([]);
    const [isUserSpecific, setIsUserSpecific] = useState(!(USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) || USER_ROLES.it_admin.includes(parseInt(authData?.role_id)) || missionContext.missionManager === authData.id));
    const [missionStatistics, setMissionStatistics] = useState({});
    const peerExperts = useGetExpertsByMissionIdQuery({ missionID: id });

    const handleReloadData = (state) => {
        let tempProcesses = [];
        missionContext.processes.forEach(process => {
            if (state.some(s => s.process_id === process.id)) {
                tempProcesses.push(process);
            }
        })
        setMovements(state);
        setMissionProcesses(tempProcesses);
    }
    const isPeerReviewer = () => {
        const filteredExpert = peerExperts?.data?.find(expert => (expert?.expert.user_id === authData?.id && expert.position_id === EXPERTS_POSITIONS.peer_reviewer));
        if (filteredExpert) {
            return true;
        } else {
            return false;
        }
    };
    useEffect(() => {
        setMissionProcesses(missionContext.processes);
        setMovements(missionContext.movements);
        if (USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) || USER_ROLES.it_admin.includes(parseInt(authData?.role_id))) {
            setMissionStatistics(getMissionWorkFlowStatistics(missionContext.processes, missionContext.movements, missionContext.missionManager));
        } else if (USER_ROLES.experts.includes(parseInt(authData.role_id)) && isPeerReviewer()) {
            filteredProcessesBasedOnRole = missionContext.processes.filter(process => {
                if (process?.sub_processes && process.sub_processes.length > 0) {
                    return process.sub_processes?.some(subProcess => subProcess.sub_role_id === EXPERTS_POSITIONS.peer_reviewer);
                }
            }
            );
            setMissionStatistics(getMissionWorkFlowStatistics(filteredProcessesBasedOnRole, missionContext.movements, missionContext.missionManager));
        }
        else {
            filteredProcessesBasedOnRole = missionContext.processes.filter(process => process.role_id === authData?.role_id)
            setMissionStatistics(getMissionWorkFlowStatistics(filteredProcessesBasedOnRole, missionContext.movements, missionContext.missionManager));
        }
    }, [missionContext.processes, missionContext.movements, peerExperts]);

    return (
        <React.Fragment>
            {
                missionContext.isLoading ? (
                    <React.Fragment>
                        <Skeleton variant="rounded" height={60} className="m-1" />
                        <Skeleton variant="rectangular" height={60} className="m-1" />
                        <Skeleton variant="rounded" height={60} className="m-1" />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <TaskTabsFilters
                            config={filterConfig}
                            movements={missionContext.movements}
                            movementData={movements}
                            missionManger={missionContext.missionManger}
                            reloadData={(state => handleReloadData(state))}
                            showHeading={false}
                        />
                        <MissionStatistics statistics={missionStatistics} />
                        {
                            peerExperts.status === "fulfilled" &&

                            <MissionProcessSteps
                                isUserSpecific={isUserSpecific}
                                processesData={missionProcesses}
                                isPeerReviewer={USER_ROLES.experts.includes(parseInt(authData.role_id)) && isPeerReviewer()}
                                movements={movements}
                            />
                        }

                    </React.Fragment>
                )
            }
        </React.Fragment>
    );
}

export default MissionWorkFlow;